export default "__VITE_ASSET__cdzpMYLn__"